// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown__dropdown___xB1fb"};